import {
    Card,
    CardBody,
    Input,
    TableRow,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
    Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import OnewayPickupPeriodicHikeTimeTable from 'components/onewaypickupperiodichiketime/OnewayPickupperiodicHikeTimeTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import OnewayPickupPeriodicHikeTimeServices from 'services/OnewayPickupPeriodicHikeTimeServices';
import { FiPlus } from 'react-icons/fi';
import OnewayPickupPeriodicHikeTimeDrawer from 'components/drawer/OnewayPickupPeriodicHikeTimeDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';

const OnewayPickupPeriodicHikeTime = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer } = useContext(SidebarContext);
    const { title, serviceId } = useToggleDrawer();
    const [status, setStatus] = useState('');
    const { data, loading, error } = useAsync(
        OnewayPickupPeriodicHikeTimeServices.getAllOnewayPickupPeriodicHikeTime
    );

    const isDataArray = Array.isArray(data?.data); // Check if data is an array
    const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

    const isAdmin = adminInfo?.id === 1;

    const hideView = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway hike time' && perm.view === 1
    );

    const hideDelete = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway hike time' && perm.delete === 1
    );

    const hideEdit = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway hike time' && perm.edit === 1
    );

    const hideAdd = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'oneway hike time' && perm.add === 1
    );

    const hideExport = adminInfo?.permission?.some(
        (perm) =>
            perm.id_tab === 'oneway hike time' && perm.export === 1
    );
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const {
        onewayPickupPeriodicHikeTimeRef,
        dataTable,
        serviceData,
        handleChangeOnewayPickupPeriodicHikeTime,
        currentPage,
    } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);

    const updatedData = safeData.map(({ id, ...rest }) => rest);

    useEffect(() => {
        if (serviceData.length !== 0) {
            setItemsPerPage(serviceData.length);
        }
    }, [serviceData]);

    useEffect(() => {
        if (data?.status) {
            setStatus(data.status);
        } else {
            setStatus(false);
        }
    }, [data?.status]);

    const cleanPgTime = (value) => {
        if (!value) return "";
        return value.replace(/[{}"]/g, "").trim();
    };

    const finalData = data?.data?.map((item, index) => {
        const vehicles = item.vehicles || [];

        return {
            "SI.No": index + 1,
            "From City": item.from_city?.trim(),
            "To City": item.to_city?.trim(),
            "Start Time": cleanPgTime(item.start_time),
            "End Time": cleanPgTime(item.end_time),
            "Vehicle Type": vehicles.map(v => v.vehicle_type).join(", "),
            "Hike": vehicles.map(v => `${v.hike}%`).join(", ")
        };
    });

    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <MainDrawer>
                        <OnewayPickupPeriodicHikeTimeDrawer id={serviceId} />
                    </MainDrawer>

                    <PageTitle sidebar={sidebar().sidebar} />

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <div className="flex gap-6 items-center">
                                <div className="flex-1">
                                    <Input
                                        ref={onewayPickupPeriodicHikeTimeRef}
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        autoComplete="off"
                                        placeholder="Quick Search"
                                        onChange={handleChangeOnewayPickupPeriodicHikeTime}
                                    />
                                </div>

                                {hideAdd && (
                                    <Button
                                        onClick={toggleDrawer}
                                        className="w-56 rounded-md h-10"
                                    >
                                        <span className="mr-3">
                                            <FiPlus />
                                        </span>
                                        Add Periodic Time Rate
                                    </Button>
                                )}

                                {hideExport && (
                                    <ExportDataXlsx
                                        exportDataXlsx={finalData}
                                        fileNames="Oneway Pickup Periodic Hike Time"
                                    />
                                )}
                            </div>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {serviceData.length ? (
                            <TableContainer>
                                <div
                                    className="overflow-y-scroll"
                                    style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
                                >
                                    <Table>
                                        <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                                            <TableRow>
                                                <TableCell>Sl.No.</TableCell>
                                                <TableCell>From City</TableCell>
                                                <TableCell>To City</TableCell>
                                                <TableCell>Start Time</TableCell>
                                                <TableCell>End Time</TableCell>
                                                <TableCell>Vehicle Type</TableCell>
                                                <TableCell>Hike (%)</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHeader>
                                        <OnewayPickupPeriodicHikeTimeTable
                                            OnewayPickupPeriodicHikeTime={dataTable}
                                            perpage={itemsPerPage}
                                            currentPage={currentPage}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </Table>
                                </div>
                            </TableContainer>
                        ) : (
                            <>
                                {data.status !== true ? (
                                    <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                                ) : (
                                    <NotFound title="There are no Oneway Periodic Hike Times." />
                                )}
                            </>
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default OnewayPickupPeriodicHikeTime;
